export const MOCK_RESPONSE_POST_CONTENTS_LIKES = undefined;

export const MOCK_RESPONSE_GET_CONTENTS_LIKES = undefined;

export const MOCK_RESPONSE_DELETE_CONTENTS_LIKES = undefined;

export const MOCK_RESPONSE_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE = undefined;

export const MOCK_RESPONSE_GET_ADMIN_CONTENTS_LIKES_USERS = undefined;

export const MOCK_RESPONSE_PUT_CONTENTS_FAVORITES = undefined;

export const MOCK_RESPONSE_DELETE_CONTENTS_FAVORITES = undefined;
